<!--字段配置Ec-->
<template>
  <div class="field-setting">
    <div v-if="origin === 'huoban'" class="title">规则一（来源唯一）</div>
    <div class="field-menu">
      <span>招商智投</span>
      <span>{{originType}}-crm</span>
    </div>
    <el-form label-width="200px" label-position="left" :model="formFiled" ref="formFiled" @keyup.enter.native="submitForm('formFiled')">
      <el-form-item v-for="(item,index) in formFiled" :label="item.wyFName" :prop="item.wyFCode" :key="index">
        <el-select v-model="item.channelId" clearable placeholder="请选择">
          <el-option v-for="(item,index) in channelList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="item.resType " clearable placeholder="请选择">
          <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span v-if="item.wyFName !== ''" class="arbtn" @click="addRow(index)">添加</span>
        <span v-else class="arbtn" @click="removeRow(index)">删除</span>
        <el-select style="margin-left:45px;" v-model="item.crmFCode" clearable placeholder="请选择" @change="changeFCode(index,item.crmFCode)">
          <el-option v-for="(item,index) in optionsField" :key="index" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item>
      <div class="button">
        <el-button type="primary" :disabled="loading" :loading="loading" @click="updateForm()">更新项目与来源</el-button>
        <el-button type="primary" :disabled="loading" size="small" @click="submitForm('formFiled')">保存</el-button>
      </div>
    </el-form>
    <template v-if="origin === 'huoban'">
      <div class="title">规则二（来源分配）配置了规则二将优先使用</div>
      <div class="field-menu">
        <span>招商智投</span>
        <span>{{originType}}-crm</span>
      </div>
      <div class="field-title">
        <span>项目名称</span>
        <span>来源</span>
        <span>需求总量</span>
        <span>每轮数量</span>
        <span>已分配量</span>
      </div>
      <el-form class="ruleForm" label-width="200px" label-position="left" :model="formRuleFiled" ref="formRuleFiled" @keyup.enter.native="submitRuleForm('formRuleFiled')">
        <el-form-item v-for="(item,index) in formRuleFiled" :label="item.itemName" :key="index">
          <el-select v-model="item.crmFCode" clearable placeholder="请选择" @change="changeFCode(index,item.crmFCode,'rule')">
            <el-option v-for="(item,index) in optionsField" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <span v-if="item.itemName !== ''" class="arbtn1" @click="addRuleRow(index)">添加</span>
          <span v-else class="arbtn1" @click="removeRuleRow(index)">删除</span>
          <el-input type="number" placeholder="请输入数字" v-model="item.dataNumLimit"></el-input>
          <el-input type="number" placeholder="请输入数字" v-model="item.dataNum"></el-input>
          {{item.distributeNum}}
        </el-form-item>
        <div class="button">
          <el-button type="primary" :disabled="loading" :loading="loading" @click="updateForm()">更新项目与来源</el-button>
          <el-button type="primary" :disabled="loading" size="small" @click="submitRuleForm('formRuleFiled')">保存</el-button>
        </div>
      </el-form>
    </template>
  </div>
</template>
<script>
  // import {FieldFormArgument} from '@/models/ec-setting'
  import Api from '@/api/client/ec-origin'
  import channelApi from '@/api/client/ec-basic-field'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    data () {
      return {
        loading: false,
        formFiled: [],
        formRuleFiled: [],
        optionsField: [],
        channelList: [],
        originType: '',
        typeList: [
          {
            id: 0,
            name: '不限'
          },
          {
            id: 1,
            name: '表单'
          },
          {
            id: 2,
            name: '智能聊天'
          }
        ]
      }
    },
    created () {
      if (this.origin === 'ec') {
        this.originType = 'ec'
      } else if (this.origin === 'lixiao') {
        this.originType = '励销'
      } else if (this.origin === 'xbb') {
        this.originType = '销帮帮'
      } else if (this.origin === 'huoban') {
        this.originType = '伙伴云'
        this.getDistributeRule()
      }
      this.getChannels()
      this.getField()
      this.getFieldSelect()
    },
    methods: {
      addRow (index) {
        const form = {
          channelId: null,
          crmCode: this.origin,
          resType: null,
          crmFName: '',
          wyFName: '',
          wyFCode: this.formFiled[index].wyFCode
        }
        this.formFiled.splice(index + 1, 0, form)
      },
      removeRow (index) {
        this.$confirm('确定要删除吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.formFiled.splice(index, 1)
        }).catch(() => {})
      },
      getField () {
        const crmCode = {
          crmCode: this.origin
        }
        Api.getEcField(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            const data = body.list
            if (data.length === 0) {
              this.$message.error('该账号暂无项目')
              return
            }
            this.formFiled = body.list
            this.formFiled.forEach(item => {
              item.crmCode = this.origin
            })
          } else {
            this.$message.error(body.error)
          }
        })
      },
      getDistributeRule () {
        const crmCode = {
          crmCode: this.origin
        }
        Api.getDistributRule(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            const data = body.list
            if (data.length === 0) {
              this.$message.error('该账号暂无项目')
              return
            }
            this.formRuleFiled = body.list
            this.formRuleFiled.forEach(item => {
              item.crmCode = this.origin
            })
          } else {
            this.$message.error(body.error)
          }
        })
      },
      addRuleRow (index) {
        const form = {
          itemName: '',
          itemId: this.formRuleFiled[index].itemId,
          wyCustomerId: this.formRuleFiled[index].wyCustomerId,
          crmCode: this.origin,
          crmFCode: '',
          crmFName: '',
          dataNum: 1,
          dataNumLimit: null,
          distributeNum: 0,
          sort: 0
        }
        this.formRuleFiled.splice(index + 1, 0, form)
      },
      removeRuleRow (index) {
        this.$confirm('确定要删除吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.formRuleFiled.splice(index, 1)
        }).catch(() => {})
      },
      changeFCode (index, id, type) {
        if (id !== '') {
          this.optionsField.forEach(item => {
            if (item.code === id) {
              if (type === 'rule') {
                this.formRuleFiled[index].crmFName = item.name
              } else {
                this.formFiled[index].crmFName = item.name
              }
            }
          })
        } else {
          if (type === 'rule') {
            this.formRuleFiled[index].crmFName = ''
          } else {
            this.formFiled[index].crmFName = ''
          }
        }
      },
      getFieldSelect () {
        const crmCode = {
          crmCode: this.origin
        }
        Api.getEcFieldSelect(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.optionsField = body.list
          } else {
            this.$message.error(body.error)
          }
        })
      },
      updateForm () {
        const crmCode = {
          crmCode: this.origin
        }
        this.loading = true
        Api.UpdateEcField(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.$message.success('更新成功')
            this.loading = false
            this.formFiled = body.list
            this.formFiled.forEach(item => {
              item.crmCode = this.origin
            })
            this.getFieldSelect()
          } else {
            this.$message.error(body.error)
          }
        })
      },
      getChannels () {
        channelApi.getChannels(response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            const list = body.list
            const form = {
              id: 0,
              title: '不限'
            }
            list.unshift(form)
            this.channelList = list
          } else {
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        if (this.formFiled.length === 0) {
          this.$message.error('该账号暂无项目')
          return
        }
        Api.saveEcField(this.formFiled, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.getField()
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      },
      submitRuleForm (formName) {
        if (this.formRuleFiled.length === 0) {
          this.$message.error('该账号暂无项目')
          return
        }
        Api.saveEcRuleField(this.formRuleFiled, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.getDistributeRule()
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .field-setting .el-form-item__label{
    padding-left:20px;
  }
  .field-setting .el-select{
    width:200px;
  }
  .ruleForm .el-input,.ruleForm .el-input__inner{
    width:200px!important;
    margin-right: 20px;
  }
</style>

<style scoped lang="scss">
.field-setting{
  margin-top:5px;
  .field-title{
    margin-bottom: 20px;
    span{
      display: inline-block;
      &:nth-child(1){
        width: 200px;
        padding-left:20px;
        box-sizing: border-box;
      }
      &:nth-child(2){
        width: 255px;
      }
      &:nth-child(3){
        width: 220px;
      }
      &:nth-child(4){
        width: 210px;
      }
    }
  }
  .title{
    margin-bottom: 10px;
  }
  .field-menu{
    border-bottom:1px solid rgba(235,238,245,1);
    margin-bottom:20px;
    background: #e8e8e8;
    line-height: 35px;
    span{
      display: inline-block;
      font-size:14px;
      font-weight:bold;
      color:#666;
      &:nth-child(1){
        margin-left:20px;
      }
      &:nth-child(2){
        margin-left:610px;
      }
    }
  }
  .arbtn{
    margin-left:5px;
    cursor: pointer;
  }
  .arbtn1{
    margin:0 20px 0 5px;
    cursor: pointer;
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    margin-top:60px;
    button{
      // width:100px;
      height:35px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding: 0 30px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/EcOrigin.vue